/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigInputCompletionMinLevelsOverrideAnyOf } from './taskEvaluationConfigInputCompletionMinLevelsOverrideAnyOf';

export type TaskEvaluationConfigInputCompletionMinLevelsOverride =
  TaskEvaluationConfigInputCompletionMinLevelsOverrideAnyOf | null;
